import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import AdminRoute from './components/AdminRoute'
import Header from './components/Header'
import Navigation from './components/Navigation'
import LandingPage from './pages/LandingPage'
import DeviceManagement from './pages/DeviceManagement'
import PartsManagement from './pages/PartsManagement'
import InventoryManagement from './pages/InventoryManagement'
import BOMManagement from './pages/BOMManagement'
import WorkOrders from './pages/WorkOrders'
import Reporting from './pages/Reporting'
import AuditLog from './pages/AuditLog'
import ModelManagement from './pages/ModelManagement'
import ModelCategoryManagement from './pages/ModelCategoryManagement'
import ManufacturerManagement from './pages/ManufacturerManagement'
import { lightTheme } from './theme/vulcan'
import { GlobalStyles } from './theme/GlobalStyles'
import { AppContainer, MainContainer, MainContent } from './components/Layout.styles'

function App() {
  return (
    <ThemeProvider theme={lightTheme}>
      <GlobalStyles />
      <AuthProvider>
        <Router>
          <AppContainer>
            <ProtectedRoute>
              <Header />
              <MainContainer>
                <Navigation />
                <MainContent>
                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/device-management" element={<DeviceManagement />} />
                    <Route path="/parts" element={<PartsManagement />} />
                    <Route path="/inventory" element={<InventoryManagement />} />
                    <Route path="/bom" element={<BOMManagement />} />
                    <Route path="/work-orders" element={<WorkOrders />} />
                    <Route path="/reporting" element={<Reporting />} />
                    <Route path="/audit-log" element={
                      <AdminRoute>
                        <AuditLog />
                      </AdminRoute>
                    } />
                    <Route path="/models" element={
                      <AdminRoute>
                        <ModelManagement />
                      </AdminRoute>
                    } />
                    <Route path="/model-categories" element={
                      <AdminRoute>
                        <ModelCategoryManagement />
                      </AdminRoute>
                    } />
                    <Route path="/manufacturers" element={
                      <AdminRoute>
                        <ManufacturerManagement />
                      </AdminRoute>
                    } />
                  </Routes>
                </MainContent>
              </MainContainer>
            </ProtectedRoute>
          </AppContainer>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App